export const routerMetaConfig = {
  de: {
    home: {
      title:
        "Shop Gutscheine - Erhalten Sie Rabattangebote online, exklusive Angebote | Nakarta Deutschland",
      description:
        "Unsere Mission, beim Online-Kauf Geld zu sparen. Finden und wählen Sie die besten Shop-Gutscheine, Gutscheincodes und Rabattangebots codes in Ihren bevorzugten Online-Shops bei Nakarta Deutschland",
      keywords:
        "Gutscheine kaufen, Rabatt online erhalten, Rabattangebots code, Gutscheincodes, Angebote"
    },
    shops: {
      title:
        "Hier finden Sie Shop Gutscheine, Gutscheincodes und Rabatte | Nakarta Deutschland",
      description:
        "Wir sind stolz darauf, unseren Benutzern zu helfen, Produkte zu den besten Preisen zu finden. Wir sind Shop-Gutscheine und Rabatt-Angebote, Aktionen von Online Shops Deutschland veröffentlicht",
      keywords:
        "Shop-Gutscheine finden, Gutscheincodes finden, Rabatte, Rabattangebots code Deutschland, Shop-Gutscheine finden Deutschland"
    },
    about: {
      title: about => `${about} - Nakarta Deutschland`
    },
    products: {
      title: "Produktvergleich - besten Shop Gutscheinangebote | Nakarta Deutschland"
    },
    category: {
      title: cat =>
        `${cat} - besten Shop Gutscheinangebote | Nakarta Deutschland`
    }
  },
  us: {
    home: {
      title:
        "Shop coupons - Get discount offers online, exclusive deals | Nakarta US",
      description:
        "Our mission to save you money when buying online. Find & choose the best shop coupons and voucher codes and discount offers codes at your favorite online shops with Nakarta US",
      keywords:
        "coupons, shop coupons, get discount online, discount offers, Voucher Codes"
    },
    shops: {
      title: "Find shop coupons, voucher codes and discounts | Nakarta US",
      description:
        "We are proud to help our users find products at the best prices. We are published shops coupons and discount offers, promotions of online shops US",
      keywords:
        "Find shop coupons, find voucher codes, shops discount, discounts, Find shop coupons us"
    },
    about: {
      title: about => `${about} Nakarta US`
    },
    products: {
      title: "Products comparison - best shop coupons offers | Nakarta US"
    },
    category: {
      title: cat => `${cat} - best shop coupons offers | Nakarta US`
    }
  },
  uk: {
    home: {
      title:
        "Shop coupons - Get discount offers online, exclusive deals | Nakarta UK",
      description:
        "Our main mission to save you money when buying online. Choose the best shop coupons and voucher codes and discount offers codes at your favorite online shops with Nakarta UK",
      keywords:
        "coupons, shop coupons, get discount online, discount offers, Voucher Codes"
    },
    shops: {
      title: "Find shop coupons, voucher codes and discounts | Nakarta UK",
      description:
        "We are proud to help our users find products at the best prices. We are published shops coupons and discount offers, promotions of online shops UK",
      keywords:
        "Find shop coupons, find voucher codes, shops discount, discounts, Find shop coupons uk"
    },
    about: {
      title: about => `${about} Nakarta UK`
    },
    products: {
      title: "Products comparison - best shop coupons offers | Nakarta UK"
    },
    category: {
      title: cat => `${cat} - best shop coupons offers | Nakarta UK`
    }
  },
  br: {
    home: {
      title:
        "Cupons da loja - obtenha ofertas de descontos online e promoções exclusivas | Nakarta Brazil",
      description:
        "Nossa principal missão de economizar dinheiro ao comprar online. Escolha os melhores cupons de loja e códigos de cupom e códigos de ofertas de desconto em suas lojas online favoritas com Nakarta Brazil",
      keywords: "cupons de lojas, obter descontos online, códigos promocionais"
    },
    shops: {
      title:
        "Encontre cupons, códigos promocionais e descontos | Nakarta Brazil",
      description:
        "Temos orgulho em ajudar nossos usuários a encontrar produtos com os melhores preços. Publicamos cupons de lojas e descontos, promoções de lojas online Brasil",
      keywords: "Encontre cupons de loja, encontre códigos de cupom, descontos"
    },
    about: {
      title: about => `${about} - Nakarta Brazil`
    },
    products: {
      title: 'Comparação entre produtos - melhores cupons de loja oferece | Nakarta Brazil'
    },
    category: {
      title: cat => `${cat} - melhores cupons de loja oferece | Nakarta Brazil`
    }
  },
  es: {
    home: {
      title:
        "Compre cupones: obtenga descuentos en línea, ofertas exclusivas | Nakarta España",
      description:
        "Nuestra misión es ahorrarle dinero al comprar en línea. Encuentre y elija los mejores cupones de tienda y códigos de cupón y códigos de ofertas de descuento en sus tiendas en línea favoritas con Nakarta España",
      keywords:
        "cupones, comprar cupones, obtener descuentos en línea, ofertas de descuento, códigos de cupones"
    },
    shops: {
      title:
        "Encuentre cupones de tienda, códigos de cupón y descuentos | Nakarta España",
      description:
        "Estamos orgullosos de ayudar a nuestros usuarios a encontrar productos a los mejores precios. Somos tiendas publicadas cupones y ofertas de descuento, promociones de tiendas online España",
      keywords:
        "Encuentra cupones de tiendas, encuentra códigos de cupones, descuentos de tiendas, descuentos, encuentra cupones de tiendas españa"
    },
    about: {
      title: about => `${about} - Nakarta España`
    },
    products: {
      title: 'Comparación de productos - mejores ofertas de cupones de tienda | Nakarta España'
    },
    category: {
      title: cat =>
        `${cat} - mejores ofertas de cupones de tienda | Nakarta España`
    }
  },
  it: {
    home: {
      title:
        "Buoni negozio - Ottieni offerte di sconto online, offerte esclusive | Nakarta Italia",
      description:
        "La nostra missione per risparmiare denaro quando si acquista online. Trova e scegli i migliori coupon e codici voucher e codici di offerte di sconto nei tuoi negozi online preferiti con Nakarta Italia",
      keywords:
        "coupon, coupon negozio, ottieni sconti online, offerte sconto, codici voucher"
    },
    shops: {
      title: "Trova coupon negozio, codici voucher e sconti | Nakarta Italia",
      description:
        "Siamo orgogliosi di aiutare i nostri utenti a trovare prodotti ai migliori prezzi. Vengono pubblicati coupon negozi e offerte sconti, promozioni negozi online Italia",
      keywords:
        "trova coupon negozio, trova codici sconto, sconti negozi, sconti, trova coupon negozio italia"
    },
    about: {
      title: about => `${about} - Nakarta Italia`
    },
    products: {
      title: 'Confronto tra i prodotti - mejores ofertas de cupones de tienda | Nakarta España',
    },
    category: {
      title: cat =>
        `${cat} - mejores ofertas de cupones de tienda | Nakarta España`
    }
  },
  nl: {
    home: {
      title:
        "Winkelcoupons - Ontvang kortingsaanbiedingen online, exclusieve deals | Nakarta Nederland",
      description:
        "Onze missie om u geld te besparen bij het online kopen. Vind en kies de beste winkelcoupons en vouchercodes en kortingscodes in uw favoriete online winkels met Nakarta Nederland",
      keywords:
        "kortingsbonnen, winkelcoupons, krijg online korting, kortingsaanbiedingen, kortingscodes"
    },
    shops: {
      title:
        "Vind winkelcoupons, vouchercodes en kortingen | Nakarta Nederland",
      description:
        "We zijn er trots op om onze gebruikers te helpen producten te vinden tegen de beste prijzen. We zijn gepubliceerd winkels kortingsbonnen en kortingsaanbiedingen, promoties van online winkels Nederland",
      keywords:
        "Vind winkelcoupons, vind vouchercodes, winkelkorting, kortingen, Vind winkelcoupons Nederland"
    },
    about: {
      title: about => `${about} - Nakarta Nederland`
    },
    products: {
      title:
        "Productvergelijking - beste kortingsbonnen aanbiedingen | Nakarta Nederland"
    },
    category: {
      title: cat =>
        `${cat} - beste kortingsbonnen aanbiedingen | Nakarta Nederland`
    }
  },
  fr: {
    home: {
      title:
        "Achetez des coupons - Obtenez des offres de rabais en ligne, des offres exclusives | Nakarta France",
      description:
        "Notre mission de vous faire économiser de l'argent lors de vos achats en ligne. Trouvez et choisissez les meilleurs coupons et codes promotionnels et codes promotionnels dans vos boutiques en ligne préférées avec Nakarta France",
      keywords:
        "coupons, coupons de magasin, obtenir des rabais en ligne, offres de rabais, codes de réduction"
    },
    shops: {
      title:
        "Trouver des coupons, des codes promotionnels et des remises | Nakarta France",
      description:
        "Nous sommes fiers d'aider nos utilisateurs à trouver des produits aux meilleurs prix. Nous publions des coupons de magasins et des offres de réduction, des promotions de boutiques en ligne France",
      keywords:
        "Trouver des coupons de magasin, trouver des codes promotionnels, rabais de magasins, rabais, Trouver des coupons de magasin france"
    },
    about: {
      title: about => `${about} - Nakarta France`
    },
    products: {
      title: 'Comparaison de produits - meilleures offres de coupons de magasin | Nakarta France',
    },
    category: {
      title: cat =>
        `${cat} - meilleures offres de coupons de magasin | Nakarta France`
    }
  }
};
